import { render, staticRenderFns } from "./ResumeJobs.vue?vue&type=template&id=68b9a96a&"
import script from "./ResumeJobs.vue?vue&type=script&lang=js&"
export * from "./ResumeJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports